import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "ME_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#ME_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0h32v24H0V0z",
      fill: "#E8AA00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 4h24v16H4V4z",
      fill: "#C51918"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "ME_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 4,
      y: 4,
      width: 24,
      height: 16
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 4h24v16H4V4z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#ME_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.23 15.752a.748.748 0 00.74-.757.748.748 0 00-.74-.757.748.748 0 00-.738.757c0 .418.33.757.739.757z",
      fill: "#1E5E91"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.628 12.332c-1.937-2.251.84-6.158.84-6.158s.415 2.333 1.95 3.904c0 .111-.144.276-.291.442a2.172 2.172 0 00-.262.335c-.135.245.329.385.554.385.1 0 .157.147.207.279.062.162.115.303.234.124.216-.323-.216-1.034-.216-1.034l.684-.72.231-.467h-.231v-.48l-.162.133s-.178-.429-.522-.429c-.343 0-.45-.196-.45-.196h.45c.226 0-.036-.299-.225-.454-.085-.07-.214-.046-.33-.024-.144.026-.268.05-.268-.11 0-.175.137-.199.294-.225.103-.018.215-.037.304-.1.147-.107.345-.074.56-.039.113.019.231.038.349.038h.557c.201 0-.326.326-.326.326l.326.29.484.494-.242.144.5.485s-.17.276 0 .276c.07 0 .116.058.146.125.03-.067.077-.125.147-.125.17 0 0-.276 0-.276l.5-.485-.243-.144.485-.495.326-.29s-.527-.325-.326-.325h.557c.117 0 .236-.02.35-.038.214-.035.412-.068.559.038.089.064.2.083.304.1.157.027.294.05.294.226 0 .16-.125.136-.268.11-.116-.022-.245-.046-.33.024-.19.155-.451.454-.226.454h.45s-.106.196-.45.196c-.344 0-.521.43-.521.43l-.162-.134v.48h-.231l.23.466.684.721s-.431.711-.216 1.034c.12.179.173.038.235-.124.05-.132.106-.279.207-.279.225 0 .689-.14.553-.385-.055-.101-.159-.219-.261-.335-.147-.166-.292-.33-.292-.442 1.536-1.57 1.951-3.904 1.951-3.904s2.777 3.907.84 6.158c-1.938 2.252-3.36 1.573-3.36 1.573l.794.712-.225.195h.662l-.244.163.18.078.19.083s-.512.376 0 .376c.08 0 .165-.002.253-.005.097-.002.196-.005.296-.005.026 0-.033-.147-.093-.293-.058-.145-.116-.288-.09-.286.055.002.164.133.273.264.087.105.174.21.234.251.04.026.191-.027.332-.076.12-.041.23-.08.259-.066.119.06.088.182.06.297a1.14 1.14 0 00-.02.087c-.004.026.148-.073.308-.177.168-.11.345-.224.359-.207a.28.28 0 00.009.011c.057.07.15.18-.53.704 0 .101.003.183.006.25.009.215.011.27-.134.27-.065 0-.155.032-.26.07-.269.095-.632.223-.896-.07-.367-.408-.93-1.019-.93-1.019v.3l-.666-.676-.128.376-.896-1.03-.242.135s.825 2.278 1.266 2.294c.22.008-.113.22-.555.503-.446.285-1.004.641-1.211.928-.062.085-.11-.046-.147-.33-.036.284-.084.415-.146.33-.207-.287-.765-.643-1.212-.928-.44-.282-.774-.495-.555-.503.442-.016 1.267-2.294 1.267-2.294l-.242-.135-.897 1.03-.128-.376-.666.677v-.3s-.562.61-.93 1.018c-.263.293-.626.165-.895.07-.105-.038-.195-.07-.26-.07-.23 0-.308-.323 0-.718.26-.334.799-.319 1.268-.306.088.003.174.005.255.005.51 0 0-.376 0-.376l.19-.083.178-.078-.243-.163h.662l-.225-.195.794-.712s-1.423.679-3.36-1.572z",
      fill: "#F6C540"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.433 17.03l-.875-1.534s-1.144-2.638-1.144-2.958c0-.32-.46-1.269-.46-.993v.993l1.93 4.35v.342h.26l.289-.2z",
      fill: "#F6C540"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M19.443 14.965l.133-.442 1.626.49-.133.442-1.626-.49z",
      fill: "#F6C540"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M20.308 14.161l.44.144-.43 1.378-.44-.144.43-1.378z",
      fill: "#F6C540"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.72 13.711l-.095-.021-.038.152-.175-.043-.021.093.172.042-.043.173.094.022.043-.172.17.042.022-.093-.168-.041.038-.154zM15.694 5.223l.047.166h.146l.047-.166c.12.036.23.077.327.123l.004-.037c.772.07 1.172.394 1.13.962-.036.47-.275.717-.672.71v.352s-.646.248-.97.248c-.322 0-.968-.248-.968-.248v-.358c-.327-.04-.521-.282-.553-.704-.043-.568.357-.891 1.13-.962l.003.038c.098-.046.208-.088.329-.124zm-.817 1.444c-.043.012-.072.02-.085.025-.178-.034-.264-.175-.284-.441-.02-.269.105-.456.402-.564-.203.26-.218.591-.033.98zm.275-.072c.163-.039.352-.078.504-.091v-.971c-.622.217-.77.55-.504 1.062zm.78-.082c.208.027.46.09.623.133l-.082-.045c.277-.526.116-.864-.54-1.082v.994zm.787-.825c.207.268.217.609.016 1.011.245.004.36-.137.383-.448.02-.268-.105-.454-.4-.563z",
      fill: "#F6C540"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.755 5.52a.323.323 0 100-.647.323.323 0 000 .646z",
      fill: "#3D58DB"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.8 4.497l-.097.002v.158h-.18l.003.095h.176v.178l.097-.002V4.75h.176l-.002-.095H15.8v-.159z",
      fill: "#F6C540"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.954 10.36s1.137-.214 1.753-.214c.553 0 1.754.214 1.754.214 0 1.36.383 2.193 0 3.122-.383.929-1.318.482-1.741 1.371-.541-.843-1.272-.379-1.767-1.58-.494-1.2.301-1.753 0-2.913z",
      fill: "#1E5E91"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "ME_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 13,
      y: 10,
      width: 5,
      height: 5
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.954 10.36s1.137-.214 1.753-.214c.553 0 1.754.214 1.754.214 0 1.36.383 2.193 0 3.122-.383.929-1.318.482-1.741 1.371-.541-.843-1.272-.379-1.767-1.58-.494-1.2.301-1.753 0-2.913z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#ME_svg__c)" }, /* @__PURE__ */ e.createElement("path", { fill: "#5EAA22", d: "M13.953 13.198h3.508v1.703h-3.508z" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.991 11.03c-.134-.284.704-.317.704-.317s.181.318 0 .77c-.131.33.088.3.39.26.114-.016.24-.032.362-.032.188 0 .287-.014.37.017.114.043.196.173.441.547.112.172.107.285.039.352.005.174-.184.318-.534.41l-.046-.183c.185-.048.299-.095.351-.147-.264.016-.62-.114-.62-.282 0-.248-.846-.196-1.354-.164-.13.008-.237.014-.304.014-.295 0-.069-.36.138-.69l.063-.102c.106-.171.14-.215.132-.248-.008-.035-.063-.059-.132-.204zm2.01-.043c-.506-.08-.79-.003-.79.28 0 .27.27.387.763.386a.72.72 0 01.05.018.816.816 0 01-.067.028l.061.178c.311-.112.311-.312-.004-.41l-.013-.004h-.014c-.41.004-.591-.073-.591-.195 0-.111.172-.159.577-.094l.029-.187z",
      fill: "#F6C540"
    }
  ))))
), c = t;
export {
  c as default
};
